import { render } from "./EditPharmacy.vue?vue&type=template&id=213ff7b6&ts=true"
import script from "./EditPharmacy.vue?vue&type=script&lang=ts"
export * from "./EditPharmacy.vue?vue&type=script&lang=ts"

import "./EditPharmacy.vue?vue&type=style&index=0&id=213ff7b6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__